module.exports = __webpack_public_path__ + "img/vrkaufs-unterstutzung.8d2e76c4.svg";